import PropTypes from 'prop-types';
import React from 'react';
import s from './WorkTracker.module.scss';
import { SORT_OPTIONS } from './lib/sorting';

const VIEWS = [{ value: 'list', label: 'List' }, { value: 'calendar', label: 'Calendar' }];
const TABS = [
  { value: 'active', label: 'Active' },
  { value: 'complete', label: 'Complete' },
  { value: 'all', label: 'All' },
];

const Segmented = ({
  options, value, onChange, label,
}) => (
  <div className={s.segment} role="group" aria-label={label}>
    {options.map((o) => (
      <button type="button" key={o.value} aria-pressed={value === o.value} onClick={() => onChange(o.value)}>
        {o.label}
      </button>
    ))}
  </div>
);

export default function Toolbar({
  view, onView, tab, onTab, sort, onSort, search, onSearch, onNewTask,
}) {
  const sortOptions = SORT_OPTIONS.filter((o) => !o.completeOnly || tab === 'complete');
  return (
    <div className={s.toolbar}>
      <Segmented label="View" value={view} onChange={onView} options={VIEWS} />
      <Segmented label="Status" value={tab} onChange={onTab} options={TABS} />
      <select className={s.select} value={sort} onChange={(e) => onSort(e.target.value)} aria-label="Sort">
        {sortOptions.map((o) => <option key={o.value} value={o.value}>{`Sort: ${o.label}`}</option>)}
      </select>
      <input
        type="search"
        className={`${s.input} ${s.search}`}
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Search titles and descriptions"
        aria-label="Search tasks"
      />
      <span className={s.spacer} />
      <button type="button" className={s.btnPrimary} onClick={onNewTask}>New Task</button>
    </div>
  );
}

Segmented.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired }),
  ).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

Toolbar.propTypes = {
  view: PropTypes.string.isRequired,
  onView: PropTypes.func.isRequired,
  tab: PropTypes.string.isRequired,
  onTab: PropTypes.func.isRequired,
  sort: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  onNewTask: PropTypes.func.isRequired,
};
